__turbopack_context__.v({
  "className": "marianne_2238f25d-module__odsFZq__className",
  "variable": "marianne_2238f25d-module__odsFZq__variable",
});
